export enum NGOBusinessTypeEnum {
  PROFIT = 'PROFIT',
  NON_PROFIT = 'NON_PROFIT',
}